import { formatDay } from "helpers/periods";
import { moduleToFallback } from "helpers/module";
import { usePeriodStrings } from "translation/periodManagement";

const K = "period_management.first.summary";

/**
 * The last step before the first period of a module exists (LIX-1760).
 *
 * There is no source, so there is no takeover to restate and nothing that
 * cannot be undone. The step stays so the period's identity is shown once
 * before it is created (LIX-1706), but without the takeover's confirmation
 * tick: one row of facts, and the takeover column says plainly that there is
 * none. It reuses the takeover summary's head so both read as the same screen.
 */
export default function PeriodFirstSummary({ module, newName, start, end }) {
  const { pt } = usePeriodStrings();

  return (
    <div className="peb-summary" data-testid="first-period-summary">
      <p className="peb-summary__lede">{pt(`${K}.lede`)}</p>

      <div className="peb-summary__head">
        <span className="peb-summary__kv">
          <span className="peb-summary__k">{pt(`${K}.head.module`)}</span>
          <span className="peb-summary__v" data-testid="summary-module">{moduleToFallback(module)}</span>
        </span>
        <span className="peb-summary__kv">
          <span className="peb-summary__k">{pt("period_management.takeover.summary.head.new")}</span>
          <span className="peb-summary__v" data-testid="summary-name">{newName}</span>
        </span>
        <span className="peb-summary__kv">
          <span className="peb-summary__k">{pt("period_management.detail.evaluation_period")}</span>
          <span className="peb-summary__v" data-testid="summary-range">
            {formatDay(start)} - {formatDay(end)}
          </span>
        </span>
        <span className="peb-summary__kv">
          <span className="peb-summary__k">{pt(`${K}.head.takeover`)}</span>
          <span className="peb-summary__v" data-testid="summary-takeover">{pt(`${K}.takeover_none`)}</span>
        </span>
      </div>
    </div>
  );
}
